import { render, staticRenderFns } from "./EmailTemplate.vue?vue&type=template&id=6e0489af&scoped=true"
import script from "./EmailTemplate.vue?vue&type=script&lang=js"
export * from "./EmailTemplate.vue?vue&type=script&lang=js"
import style0 from "./EmailTemplate.vue?vue&type=style&index=0&id=6e0489af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0489af",
  null
  
)

export default component.exports